const Form059TC = {
    stepName: {
        ImportantNotes: "重要提示",
        ApplicationInfo: "学校资料",
        PartA: "缔结内地姊妹学校意愿表",
        // PartB: "乙部：学校特色",
        PartB: "内地姊妹学校申报表",
        // OtherReason: "附件",
        Confirmation: "确认",
    },
    importantNotesTemp: {
        noteOne: "1. 本电子表格是用于网上提交：",
        noteOne_a: "姊妹学校计划津贴申请表",
        noteOne_b: "内地姊妹学校申报表",
        noteOne_c: "缔结内地姊妹学校意愿表",
        noteTwo:
            "2. 在填写表格前请先参阅教育局通告第9/2025号「全方位学习及姊妹学校津贴」",
        noteTwo_a:
            "https://applications.edb.gov.hk/circular/upload/EDBC/EDBC25009S.pdf",
        noteThree:
            "3. 如电子提交的所有档案字节总和超出每次上载的10MB限制，提交者应改为採用每次不超出上载限制的分次电子提交方式。",
        noteFour:
            "4. 如申请学校未能按要求提供必须的资料，将可能导致本局未能处理有关申请。",
        noteFive:
            "5. 申请学校须留意在电子表格内提供的姊妹学校计划负责老师姓名，以便本局人员就津贴事宜联络学校。",
        noteSix:
            "6. 如对提交的电子表格有任何查询，请与教育局学校发展支援组联络：",
        noteSix_a: "地址：香港添马添美道2号政府总部东翼5楼",
        noteSix_b: "电话号码：	3509 8482",
        noteSix_c: "传真号码：	2891 2593",
        noteSix_d: "电邮地址：	sds1@edb.gov.hk",
    },

    importantNotes: {
        p1_1: "个人资料收集声明",
        p1_2: "教育局会利用本表格所载的个人资料，作以下其中一种或多种用途︰",

        p1_a: "办理与聘用有关的事宜；",
        p1_b: "处理发放薪金津贴，以及计算公积金的供款和赠款；",
        p1_c: "进行核数工作；",
        p1_d: "进行研究及统计资料，以便规划教育服务；",
        p1_e: "处理有关教育专业人员发展的事宜；",
        p1_f: "执行《教育条例》、《教育规例》及附属《补助/津贴学校公积金规则》(第279章)。",

        p2: "申请人必须在本表格上填写个人资料。申请人如不提供这些资料，申请的处理工作及结果或会受影响。",
        p3: "本表格所搜集的个人资料，或会向其他获授权的政府决策局/部门/机构披露作上述用途。",
        p4: "根据《个人资料(私隐)条例》，第18和22条及附表1保障资料第6原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        p5: "如欲查询有关本表格所搜集的个人资料，包括要求查阅及改正资料事宜，需以书面方式向教育局提出。",
    },

    label: {
        iamStatement:
            "本人理解申请人和学校批核人员需要拥有「智方便+」帐户才能处理申请。如果你或学校的批核人员没有“iAM Smart+”帐户，请在<a href='https://www.edb.gov.hk/sc/sch-admin/admin/about-sch/sister-sch-scheme/sister-sch-scheme-index.html' style='color:black;' target='_blank'><b><u>此处</u></b></a>下载纸本表格并通过邮寄方式提交。",
        subjectArea: "学科",
        statement: "本人已阅读丶理解及同意上述条款及细则",
        applicationForm: "学校资料",
        partALocationOne: "地域",
        PartBSchoolCharacteristics: "学校特色",
        partCSchoolInformation: "内地姊妹学校资料",

        UploadSigningImage: "UploadSigningImage",
        eSigning: "ESigning",
        iamSmart: "IamSmart",

        rewardOption: {
            schoolInRemoteArea: "山区学校",
            experimentalSchool: "实验学校",
            foreignLanguageSchool: "外语学校",
            vocationalEducation: "职业教育",
            technologyEducation: "科技教育",
            sports: "体育",
            arts: "艺术",
            subjectArea: "学科（请注明：）",
            others: "其他（请注明：）",
            noApecificChoice: "没有特定选择",
        },
        pleaseSpecifycity: "请指定城市",
        pleaseSpecify: "请注明",
        government: "官立",
        aided: "资助",
        dss: "直接资助",
        caput: "按位津贴",
        secondary: "中学",
        primary: "小学",
        special: "特殊学校",
        schoolType: "学校类别：",
        schoolTypeOption: {
            secondary: "中学",
            primary: "小学",
            special: "特殊学校",
        },
        financeType: "资助类别：",
        financeTypeOption: {
            government: "官立",
            aided: "资助",
            dss: "直接资助",
            caput: "按位津贴",
        },
        schoolAddress: "学校地址",
        schoolTel: "学校电话",
        schoolFax: "传真号码",
        schoolName: "学校名称",
        telephone: "学校电话",
        schoolEmailAddress: "学校电邮",
        nameOfPrincipal: "校长姓名",
        teacherName: "校监／校管会主席姓名",
        teacherPost: "网上平台负责老师职位",
        pleaseSelectAPlan: "请选择一个计划",
        GrantfortheSisterSchoolSchemeApplicationForm:
            "本校已参加姊妹学校计划 ／ 及 ／ 试办计划*",
        SisterSchoolSchemeIndicationofPreferenceforPairingUpwithMainlandSchools:
            "本校仍未参加姊妹学校计划或试办计划，但已与内地学校缔结为姊妹学校(请同时提交附件5)",
        SisterSchoolSchemeReportingFormonMainlandSisterSchools:
            "本校仍未有姊妹学校，希望透过教育局协调与内地学校缔结姊妹学校(请同时提交附件6)",
        AreaDetail:
            "# 即广州市丶深圳市丶珠海市丶佛山市丶惠州市丶东莞市丶中山市丶江门市和肇庆市",
        platformName: "姊妹学校／网上平台負責老師姓名",
        teacherNameCharge: "負責老師姓名",
        tooltips:
            "网上平台指由教育局开设的姊妹学校网上平台。教育局会就开启帐号的事宜稍后联络负责老师。(只适用于尚未开启帐号的学校)",
        partaTooltips: "请在下面的方格内填上1至8的意愿",
        platform: "姊妹学校／网上平台负责老师职位：",
        post: "職位",
        platformType: {
            VicePrincipal: "副校长",
            seniorTeacher: "主任",
            teacher: "老师",
            others: "其他",
        },
        // schoolChoiceType: {
        //     schoolChoiceTypeA:
        //         "本校仍未参加姊妹学校计划或试办计划，但已与内地学校缔结为姊妹学校（请同时提交附件）。",
        //     schoolChoiceTypeB:
        //         "本校仍未有姊妹学校，希望透过教育局协调与内地学校缔结姊妹（请同时提交附件）。",
        // },
        // schoolChoice: {
        //     OurSchoolHasJoined: "本校已参加",
        //     TheSisterSchoolScheme: "姊妹学校计划",
        //     ThePilotScheme: "试办计划",
        // },
        schoolAllChoiceTypeA: {
            schoolChoiceTypeA: "现申请姊妹学校计划津贴。",
        },

        schoolAllChoiceType: {
            schoolChoiceTypeC: "现提交缔结内地姊妹学校意愿表。",
            schoolChoiceTypeB: "现提交内地姊妹学校申报表。",
        },

        schoolAllChoice: {
            hasJoined: "本校已参加姊妹学校计划。",
        },
        schoolAllChoiceTemp: {
            hasNotJoined:
                "本校仍未参加姊妹学校计划，但已与内地学校缔结为姊妹学校。",
            noSisterSchool:
                "本校仍未有姊妹学校，希望透过教育局协调与内地学校缔结姊妹学校。",
        },
        schoolAllSelect: {
            schoolChoiceTypeA: "现申请姊妹学校计划津贴。",
            schoolChoiceTypeC: "现提交缔结内地姊妹学校意愿表。",
            schoolChoiceTypeB: "现提交内地姊妹学校申报表。",
            hasJoined: "本校已参加姊妹学校计划。",
            hasNotJoined:
                "本校仍未参加姊妹学校计划，但已与内地学校缔结为姊妹学校。",
            noSisterSchool:
                "本校仍未有姊妹学校，希望透过教育局协调与内地学校缔结姊妹学校。",
        },
        management:
            "获法团校董会／校董会／学校管理委员会（校管会）同意，本校：",
        managementType: {
            yes: "是",
            no: "否",
        },
        platformNameNotes:
            "网上平台指由教育局开设的姊妹学校网上平台。教育局会就开启账号的事宜稍后联络负责老师。（只适用于尚未开启账号的学校）",

        platformNotes:
            "电子平台是指教育局为姊妹学校设立的电子平台。教育局将在适当时候联系主管教师，了解用户帐户的创建情况(仅适用於没有用户帐户的学校）。",
        partaNotes:
            "本校希望透过教育局协调，与内地学校缔结为姊妹学校，意愿如下：",
        partAlabel: {
            pleaseSpecify: "请注明：",
            province: "地区：",
            location: "地点",
            preference: "意愿",
            preferenceText: "(请在以下方格填上1-8 的意愿, 1为最优先)",
            notes: "即广州市丶深圳市丶珠海市丶佛山市丶惠州市丶东莞市丶中山市丶江门市和肇庆市",
            locationList: {
                sichuanProvince: "四川省",
                hainanProvince: "海南省",
                shanghaiMunicipality: "上海市",
                beijingMunicipality: "北京市",
                fujianProvince: "福建省",
                bayArea: "大湾区",
                citiesInOtherGuangdongProvinc: "广东省其他地市 (请注明:)",
                otherProvincesOrcities: "其他省市 (请注明:)",
            },
            otherGuangdongCitiesSpecifyOne: "广东省其他城市 1",
            otherGuangdongCitiesSpecifyTwo: "广东省其他城市 2",
            otherGuangdongCitiesSpecifyThree: "广东省其他城市 3",
            otherGuangdongCitiesSpecifyFour: "广东省其他城市 4",
            otherGuangdongCitiesSpecifyFive: "广东省其他城市 5",

            otherProvincesOrcitiesSpecifyOne: "其他省市 1",
            otherProvincesOrcitiesSpecifyTwo: "其他省市 2",
            otherProvincesOrcitiesSpecifyThree: "其他省市 3",
            otherProvincesOrcitiesSpecifyFour: "其他省市 4",
            otherProvincesOrcitiesSpecifyFive: "其他省市 5",
            city: "城市",
            provinceOrCity: "省市",
        },
        partBlabel: {
            notes: "本校明白以上意愿将作配对时参考之用，最终配对结果须视乎实际情况而定。如有特殊原因未能与教育局安排的学校缔结为姊妹学校，本校会以书面形式提出及交代原因。",
            PleaseSpecify: "请注明",
        },
        partClabel: {
            schoolName: "姊妹学校名称",
            schoolType: "姊妹学校类别：",
            yearOfFormingSisterSchool: "缔结年份",
            province: "省",
            city: "市",
            area: "区",
            ourSchool: "我们学校：",
            and: "和：",
            partcJoin: {
                hasJoined: "已参加姊妹学校计划",
                hasNotJoined: "从未参加姊妹学校计划",
            },

            partcPair: {
                hasPaired: "已缔结内地姊妹学校",
                hasNewlyPaired: "已新增内地姊妹学校",
            },
            supportDocs: "证明文件",
        },
        schoolChoose: {
            locationProvinces: "按本校以下的次序配对",
            AnyProvinces: "由教育局安排的任何省市",
        },
        location: "姊妹学校所属省市及地区",
        schoolInfomation: "本校已<b>缔结／新增</b>的内地姊妹学校资料如下：",
    },
    errorMsg: {
        abOrc: "請选择a)或b)／c)",
        prefDistinct: "相同意愿数字不能出现超过一次",
        emptyPreference: "请输入您的意愿",
        order: "请顺序输入",
        dialogTitle: "失败",
        dialogContent:
            "当选择「内地姊妹学校申报表」以外的其他表格时，只有主管人员可以在申请表上签名。",
        dialogContentForOnlyOption3:
            "当只选择「内地姊妹学校申报表」表格时，只有校长可以在申请表上签名。",
    },
};
export default Form059TC;
